<!---数据统计--->
<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="班次消费表"
      :page="false"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.getShiftStat"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="params.ConsumeStartDate"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="开始日期"
            :editable="false"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="params.ConsumeEndDate"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="开始日期"
            :editable="false"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="营业网点">
          <el-select v-model="params.Buildings" multiple>
            <el-option v-for="(i,key) in BuildingList" :key="key" :label="i" :value="i"></el-option>
          </el-select>
          <!-- <el-input v-model="params.Building" placeholder="请输入营业网点" clearable /> -->
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Building" label="营业网点" min-width="120" />
        <el-table-column prop="MealName" label="班次" />
        <el-table-column prop="GroupName" label="营业小组" />
        <el-table-column prop="MemberCount" label="总人数" />
        <el-table-column prop="ConsumeCount" label="总人次" />
        <el-table-column prop="ConsumeAmount" label="总交易金额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/cp/consume").default,
      params: {
        ConsumeStartDate: this.$commonJs.getToday(),
        ConsumeEndDate: this.$commonJs.getToday(),
        Building: "",
        Buildings: [],
      },
      BuildingList: [],
    };
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.exportShiftStat(params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>